import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
try {
  root.render(
    <App />
  );
  console.log('✅ React mounted successfully');
} catch (error) {
  console.error('❌ React mount error:', error);
  document.body.innerHTML = '<div style="padding:20px;font-family:sans-serif;"><h1>Error Loading App</h1><pre>' + error.message + '</pre></div>';
}